<template>
  <div class="createcheckAct">
    <template>
      <el-form ref="form" :model="formOne" label-width="90px" size="small">
        <el-form-item label="适用门店">
          <el-button type="primary" plain size="small">添加门店</el-button>
        </el-form-item>

        <el-form-item label="费率">
          <div>费率详细说明</div>
        </el-form-item>

        <el-form-item label="活动类型">
          <el-radio-group v-model="formOne.resource">
            <el-radio label="折扣"></el-radio>
            <el-radio label="满减"></el-radio>
            <el-radio label="原价"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="活动规则">
          <el-input v-model="input" placeholder="请输入内容" size="small" class="width220"></el-input>折
        </el-form-item>
      </el-form>
    </template>

    <template>
      <div class="headline">套餐名称</div>
      <el-form ref="form" :model="formOne" label-width="90px" size="small">
        <el-form-item label="活动有效期">
          自上线日起至
          <el-input v-model="input" placeholder="请输入内容" size="small" class="width220"></el-input>(截止到当天23:59:59）
        </el-form-item>

        <el-form-item label="自动延期">
          <el-radio-group v-model="formOne.resource">
            <el-radio label="到期后自动延长30天有效期"></el-radio>
            <el-radio label="到期后不自动延期"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="不可用日期">
          <el-radio-group v-model="formOne.resource">
            <el-radio label="所有日期都可用"></el-radio>
            <el-radio label="部分日期都不可用"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="使用时间">
          <el-radio-group v-model="formOne.resource">
            <el-radio label="营业时间内可用"></el-radio>
            <el-radio label="部分时间可用"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="适用范围">
          <el-radio-group v-model="formOne.resource">
            <el-radio label="全场通用"></el-radio>
            <el-radio label="部分商品不可用"></el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="售卖平台">
          <el-radio-group v-model="formOne.resource">
            <el-radio label="美团+点评"></el-radio>
            <el-radio label="美团"></el-radio>
            <el-radio label="点评"></el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
    </template>
  </div>
</template>

<script>
export default {
  name: "createcheckAct", // 创建买单活动
  data() {
    return {
      formOne: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      }
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.createcheckAct {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .headline {
    margin: 20px 0px;
    font-size: 16px;
    font-weight: 600;
  }
  .hint {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
  // .el-radio-group {
  //   line-height: 42px;
  // }
  .width220 {
    margin: 0 5px;
    width: 220px;
  }
  .width220-lft {
    margin: 0 5px;
    width: 220px;
    margin-left: -20px;
  }
  .width130 {
    margin: 0 5px;
    width: 130px;
    padding-bottom: 10px;
  }
  .width130-lft {
    margin: 0 5px;
    width: 130px;
    margin-left: -20px;
    padding-bottom: 10px;
  }
}
</style>

<style lang="scss">
.createcheckAct {
  .el-input-group__append {
    padding: 0 10px;
  }
}
</style>
